<div id="ReadOnlyMap-container" [class.mobile]="isMobile()">
  @if (isLoading()) {
    <div class="spinner-container">
      <app-spinner></app-spinner>
    </div>
  }
  <div class="inset-shadow-container"></div>
  <div id="ReadOnlyMap"></div>
</div>
